export const noCreateAllowedFor = new Set([
    'categoryOptionCombo',
]);

export default {
    baseUrl: '/api',
    i18n: {
        sources: new Set(),
        strings: new Set(),
    },
};



/** WEBPACK FOOTER **
 ** ./src/defaultConfig.js
 **/